module.exports = __webpack_public_path__ + "static/EnmTX_BosMiguel_L_B_cl-aa257562933e947c0d40b20babf358fa.gif";